<template>
    <div class="container">
        <div class="row">
            <div class="col-xl-12 col-12 mb-3">
                <div class="card">
                    <div class="card-header blue-gradient">Agenda</div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 col-xl-8 mx-auto">
                                <div class="row">
                                    <div class="col-12 col-xl-6">
                                        <div class="form-group">
                                            <label for="name">Fecha</label>
                                            <input readonly type="text" class="form-control" placeholder="Nombre de la nueva área" v-model="schedule.date_format">
                                        </div>
                                    </div>
                                    <div class="col-12 col-xl-6">
                                        <div class="form-group">
                                            <label for="name">Hora</label>
                                            <input readonly type="text" class="form-control" placeholder="Nombre de la nueva área" v-model="schedule.time_format">
                                        </div>
                                    </div>

                                    <div class="col-12 col-xl-6">
                                        <div class="form-group">
                                            <label for="name">Nombres usuario</label>
                                            <input readonly type="text" class="form-control" placeholder="Nombre de la nueva área" v-model="schedule.first_name">
                                        </div>
                                    </div>

                                    <div class="col-12 col-xl-6">
                                        <div class="form-group">
                                            <label for="name">Apellidos usuario</label>
                                            <input readonly type="text" class="form-control" placeholder="Nombre de la nueva área" v-model="schedule.last_name">
                                        </div>
                                    </div>

                                    <div class="col-12 col-xl-6">
                                        <div class="form-group">
                                            <label for="name">Genero</label>
                                            <input readonly type="text" class="form-control" placeholder="Nombre de la nueva área" v-model="schedule.gender_name">
                                        </div>
                                    </div>

                                    <div class="col-12 col-xl-6">
                                        <div class="form-group">
                                            <label for="name">Cedula usuario</label>
                                            <input readonly type="text" class="form-control" placeholder="Nombre de la nueva área" v-model="schedule.document">
                                        </div>
                                    </div>

                                    <div class="col-12 col-xl-6">
                                        <div class="form-group">
                                            <label for="name">Celular usuario</label>
                                            <input readonly type="text" class="form-control" placeholder="Nombre de la nueva área" v-model="schedule.phone_number">
                                        </div>
                                    </div>

                                    <div class="col-12 col-xl-6">
                                        <div class="form-group">
                                            <label for="name">Correo usuario</label>
                                            <input readonly type="text" class="form-control" placeholder="Nombre de la nueva área" v-model="schedule.email">
                                        </div>
                                    </div>

                                    <div class="col-12">
                                        <div class="form-group">
                                            <label for="name">Dirección usuario</label>
                                            <input readonly type="text" class="form-control" placeholder="Nombre de la nueva área" v-model="schedule.address">
                                        </div>
                                    </div>

                                    <div class="col-12">
                                        <div class="form-group">
                                            <label for="name">Codigo</label>
                                            <input readonly type="text" class="form-control" placeholder="Codigo" v-model="schedule.code">
                                        </div>
                                    </div>

                                    <div class="col-12">
                                        <div class="form-group">
                                            <label for="name" >Observaciones usuario</label>
                                            <textarea readonly v-model="schedule.observation" class="form-control"></textarea>
                                        </div>
                                    </div>

                                    <div class="col-12">
                                        <div class="form-group">
                                            <label for="name" >Imagen</label>
                                            <div v-if="schedule.picture">
                                                <img style="min-width: 100px;" :src="baseUrl + schedule.picture">
                                            </div>
                                            <div v-else>
                                                No se encontró imagen
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12">
                                        <div class="form-group">
                                            <label for="name" >Asistencia</label>
                                            <select class="form-control" name="" id="" v-model="schedule.attendance">
                                                <option value="null">Seleccionar asistencia</option>
                                                <option value="1">Asistió</option>
                                                <option value="2">No asistió</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-12">
                                        <input class="btn btn-warning" type="button" value="Actualizar asistencia" @click.prevent="updateSchedule">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>
<script>
export default {
    name: 'cities',
    mounted: function(){
        // this.fetchCities();
        this.fetchSchedule();
    },
    data(){
        return {
            baseUrl: process.env.VUE_APP_API,
            schedule: {
                date: "",
                time: '',
                first_name: '',
                last_name: '',
                gender: '',
                document: '',
                phone_number: '',
                email: '',
                address: '',
                observation: '',
                attendance: '',
                code: ''
            },
        }
    },
    methods: {
        fetchSchedule: function(){
            let _this = this;
            let loader = this.$loading.show();
            const id = this.$route.params.id;
            this.$http.get(
                `${this.baseUrl}/admin/schedules/${id}`, 
                {headers: {Authorization: `Bearer ${localStorage.getItem('session_id')}`}})
            .then(data => {
                _this.schedule = data.body.data;
                loader.hide();
            })
            .catch(error => {
                loader.hide();
            });
        },
        updateSchedule: function(){
            let loader = this.$loading.show();
            const id = this.$route.params.id;
            this.$http.put(`${this.baseUrl}/admin/schedules/${id}`, {attendance: this.schedule.attendance})
            .then(() => {
                loader.hide();
                this.$dialogs.alert(`Se ha actualizado el estado de la asistencia exitosamente`, {title: "Éxito", size: "sm"});
                this.$router.back();
            })
            .catch(error => {
                console.log(error.error);
                loader.hide();
            });
        },
    }

}
</script>
<style lang="sass" scoped>
    @import '../../assets/scss/colors';
</style>


